import React from "react";
import { Bone, Skeleton } from "@xo-union/tk-ui-skeleton";
import styles from "./styles.css";
var Loading = function Loading(_ref) {
  var isMobile = _ref.isMobile,
    smallDevice = _ref.smallDevice,
    loaded = _ref.loaded;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: loaded ? "none" : "block"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    style: {
      width: "100%",
      height: isMobile ? "auto" : "100%"
    },
    "aria-label": "Loading designer card"
  }, /*#__PURE__*/React.createElement(Bone, {
    style: {
      height: smallDevice ? 160 : 140,
      width: "100%",
      marginBottom: 20
    }
  }), /*#__PURE__*/React.createElement(Bone, {
    style: {
      height: 20,
      width: 150,
      marginBottom: 10
    }
  })));
};
export default Loading;